import type { CSSProperties } from "react";

/**
 * TheCore Studio — Switch toggle.
 * Binary on/off. Knob animates with the brand spring easing.
 * Controlled: pass `checked` + `onChange`.
 */
export interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  style?: CSSProperties;
  ariaLabel?: string;
}

export function Switch({
  checked = false,
  onChange,
  disabled = false,
  style = {},
  ariaLabel,
}: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onChange?.(!checked);
      }}
      style={{
        width: 48,
        height: 28,
        borderRadius: "var(--radius-pill)",
        border: "none",
        padding: 3,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        background: checked ? "var(--brand)" : "var(--clay-300)",
        transition: "background var(--dur-base) var(--ease-out)",
        display: "inline-flex",
        alignItems: "center",
        ...style,
      }}
    >
      <span
        style={{
          width: 22,
          height: 22,
          borderRadius: "50%",
          background: "#fff",
          boxShadow: "var(--shadow-sm)",
          transform: checked ? "translateX(20px)" : "translateX(0)",
          transition: "transform var(--dur-base) var(--ease-spring)",
        }}
      />
    </button>
  );
}
